module.exports = __webpack_public_path__ + "static/level-8-bg.1200ab65.png";